// Local / dev / QA check for feature defaults (e.g. the rebate campaign flag). Narrower
// than the QA Panel allowlist, which lives in config/webpack.config.js (qaPanelAllowed).
// Intentionally written as literal `===` comparisons joined by `||` (not
// Array.prototype.includes) — DefinePlugin replaces process.env.DEPLOY_ENV
// with a literal build-time string, and this form lets bundlers constant-fold
// and dead-strip the branch in non-allowlisted builds.
export function isLocalOrQaEnvironment(): boolean {
  return (
    process.env['DEPLOY_ENV'] === 'LOCAL' ||
    process.env['DEPLOY_ENV'] === 'DEV' ||
    process.env['DEPLOY_ENV'] === 'QA'
  );
}

// A check for local-only environment, used to gate mock data and other dev-only features.
export function isLocalEnvironment(): boolean {
  return process.env['DEPLOY_ENV'] === 'LOCAL';
}
